import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Col, message, Modal, Row, Space } from 'antd'
import Title from 'Components/text/Title'
import { PrimaryButton } from 'Components/button'
import { MyTheme } from 'Components/common/Theme'
import Label from 'Components/text/Label'
import Dragger from 'antd/lib/upload/Dragger'
import { DownloadOutlined, InboxOutlined } from '@ant-design/icons'
import { RcFile } from 'antd/lib/upload'
import { currentDateTimeUTC } from 'helpers/format'
import { csv2json } from 'helpers/export'
import * as XLSX from 'xlsx'
import { FileProduct, ProductImportVerify } from 'Store/product/types'
import { toNumber } from 'lodash'
import { CurrentUser } from 'Store/user/types'
import { appConfig, themeConfig } from 'config'

interface Props {
  isShow: boolean
  handleOk?: (file: any, data: any[]) => void
  handleCancel?: () => void
  title?: string
  titleSecond?: string
  confirmBtnTxt?: string
  cancelBtnTxt?: string
  loading?: boolean
  description?: string
  mid?: number
  activeMerchantInfo?: CurrentUser
}

const ConfirmImportProduct = (props: Props) => {
  const {
    isShow = false,
    handleOk = () => {},
    handleCancel = () => {},
    title = 'ยืนยันการนำเช้า',
    confirmBtnTxt = 'ลบ',
    cancelBtnTxt = 'ยกเลิก',
    loading = false,
    description = '',
    titleSecond = '',
    mid = 0,
    activeMerchantInfo,
  } = props

  const [productData, setProductData] = useState([] as ProductImportVerify[])
  const [fileAttach, setFileAttach] = useState([] as any[])
  const [uploadLoading, setUploadLoading] = useState(false as boolean)

  useEffect(() => {
    return () => {
      setFileAttach([])
      setUploadLoading(false)
    }
  }, [isShow])

  const onSubmit = () => {
    handleOk(fileAttach[0], productData)
  }

  const footer = (
    <FooterStyled>
      <Row justify="center" gutter={16}>
        <Col md={8} xs={10}>
          <PrimaryButton text={cancelBtnTxt} btnType="Cancel" onClick={handleCancel} />
        </Col>
        <Col md={8} xs={10}>
          <PrimaryButton
            text={confirmBtnTxt}
            onClick={onSubmit}
            loading={false}
            disabled={fileAttach.length < 1}
          />
        </Col>
      </Row>
    </FooterStyled>
  )

  const findId = (text: string) => {
    const pattern = /\{([^)]+)\}/
    const val = text.match(pattern)
    return (val && val[1] && toNumber(val[1])) || 999
  }

  const replaceName = (text: string) => {
    return ''
    return text.replace(/ *\{[^)]*\} */g, '')
  }

  const converPrice = (price: any) => {
    //return price
    const priceNumber = Number(price || 0)
    return isNaN(priceNumber) ? 0 : priceNumber
  }

  const converId = (id: any, index: number) => {
    //return price
    const nid = Number(id || 0)
    return isNaN(nid) ? index : nid
  }

  const formatData = (data: FileProduct[]) => {
    const defaultPhoto = themeConfig.title.uploadProductImage || ''
    const finalData = [] as ProductImportVerify[]
    const lat = activeMerchantInfo?.activeMerchant?.lat || 0
    const long = activeMerchantInfo?.activeMerchant?.long || 0
    data &&
      data.forEach((item: FileProduct, index: number) => {
        finalData.push({
          key: `${item.row}`,
          id: converId(item.row, index),
          group_id: findId(item?.group_id || ''),
          category_id: findId(item?.category_id || ''),
          sub_category_id: findId(item?.sub_category_id || ''),
          title: item?.title || '',
          details: item?.details || '',
          manufacturer_id: findId(item?.manufacturer_id || ''),
          uom_id: findId(item?.uom_id || ''),
          merchant_id: mid,
          code: item?.code || '',
          model: item?.model || '',
          available_date: currentDateTimeUTC(),
          sales_discontinuation_date: currentDateTimeUTC(),
          created_at: currentDateTimeUTC(),
          updated_at: currentDateTimeUTC(),
          slug: '',
          instruction: '',
          products: '',
          manual: '',
          maintenant_and_caution: '',
          properties: '',
          status: 'inactive',
          status_pos: 'active',
          deliver_status: 'baandy',
          refund_status: 'off',
          product_warranty: 0,
          product_warranty_unit: 'months',
          enable_discount: false,
          warranty_status: 'off',
          product_refund: 0,
          product_refund_unit: 'months',
          photos: [defaultPhoto],
          lat: lat,
          long: long,
          shipping_types: '{"pickup"}',
          free_shipping: false,
          activated: true,
          request_status: 'approved',
          master_product: false,
          master_id: null,
          first_update: false,
          bound_id: null,
          tags: null,
          distance_delivery_config_id: 0,
          max_distance: 50,

          //product option
          product_option_title: item?.title || '',
          barcode: item.barcode || '',
          price: converPrice(item.price),
          offline_price: converPrice(item.offline_price || 0),
          price_a: converPrice(item.price_a),
          price_b: converPrice(item.price_b),
          price_c: converPrice(item.price_c),
          weight: 0.99,
          length: 0,
          online_percentage: 0,
          area: 0,
          height: 0,
          photo: defaultPhoto,
          quantity: 0,
          quantity_offline: 0,
          width: 0,
        })
      })
    return finalData
  }

  const uploadProps = {
    name: 'file',
    multiple: false,
    accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    beforeUpload: (file: RcFile) => {
      setUploadLoading(true)
      const reader = new FileReader()
      reader.onload = (event: any) => {
        try {
          const { result } = event.target
          const workbook = XLSX.read(result, { type: 'binary' })
          const sheetName = 'ข้อมูลสินค้าสำหรับนำเข้า'
          const ws = workbook.Sheets[sheetName]
          const csvText = XLSX.utils.sheet_to_csv(ws)
          const arrayData = csv2json(csvText) as FileProduct[]
          const finalData = formatData(arrayData)
          setProductData(finalData)
        } catch (e) {
          message.error('file type is incorrect!')
        }
        setUploadLoading(false)
        const newFile = [file]
        setFileAttach(newFile)
      }
      reader.readAsBinaryString(file)
      return false
    },
    onRemove: () => {
      setFileAttach([])
    },
    fileList: fileAttach,
    onChange() {},
    onDrop() {},
  }

  return (
    <ModalStyled visible={isShow} onCancel={handleCancel} footer={footer} centered>
      <ContentWrapper>
        <Title>{title}</Title>
        {titleSecond && <TitleSecond>{titleSecond}</TitleSecond>}
        <Description>
          <span>วิธีในการนำสินค้าเข้าด้วยไฟล์ Excel</span>
          <Space>
            <span>&nbsp;1. ดาวโหลดไฟล์ตัวอย่างในการนำสินค้าเข้าได้ที่นี่</span>
            <a href={`${appConfig.publicAssetEndpoint}/templates/FormProductImport.xlsx`} download>
              <DownloadXample>
                <Space>
                  <DownloadOutlined />
                  ดาวน์โหลดตัวอย่างไฟล์
                </Space>
              </DownloadXample>
            </a>
          </Space>
          <br />
          <span>
            &nbsp;2. นำไฟล์ตัวอย่างที่ดาวโหลดเปิดผ่านโปรแกรม Microsoft Excel ที่มีเวอร์ชัน 2016 ขึ้นไป
            หรือเปิดไฟล์ด้วย{' '}
          </span>
          <span>
            <a href="https://docs.google.com/spreadsheets" target="_blank" rel="noopener noreferrer">
              <DownloadXample>
                <Space>Google Sheets</Space>
              </DownloadXample>
            </a>
          </span>
          <span> เพื่อกรอกข้อมูลสินค้า </span>
          <br />
          &nbsp;3. กรอกข้อมูลสินค้าที่ต้องการนำเข้าตามตัวอย่างในไฟล์ <br />
          &nbsp;4. นำไฟล์ตัวอย่างที่กรอกข้อมูลสินค้าเรียบร้อยแล้วมาอัพโหลดเข้าระบบ
        </Description>

        <UploadWrapper>
          <Dragger {...uploadProps}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">คลิ๊กหรือลากไฟล์เพื่ออัพโหลด</p>
            <TextStyled>{description}</TextStyled>
          </Dragger>
        </UploadWrapper>
      </ContentWrapper>
    </ModalStyled>
  )
}

const ModalStyled = styled(Modal)`
  .ant-modal-content {
    border-radius: 6px;
  }
  .ant-modal-footer {
    border: none;
  }
`

const ContentWrapper = styled.div`
  text-align: center;
`

const FooterStyled = styled.div`
  margin-bottom: 15px;
`

const TextStyled = styled(Label)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  text-align: left;
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`
const UploadWrapper = styled.div`
  padding: 10px 0;
`

const TitleSecond = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title1};
`

const DownloadXample = styled.span`
  text-align: left;
  cursor: pointer;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const Description = styled.div`
  text-align: left;
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  padding-bottom: 20px;
  padding-top: 10px;
`

export default ConfirmImportProduct
